import assets from "@/assets/break-points";

const BreakPointFeature = [
  {
    heading: "Craft your Career with Confidence ✅ ",
    paraHeading: (
      <>
        A <span>professional resume </span> is your first step to your success,
        craft it for free with CipherSchools.
      </>
    ),
    src: assets.Resume,
    backgroundColor: "#6a1b9a",
    navigationLink: "https://www.cipherschools.com/resume-builder",
  },
  {
    heading: "Get Smart, Get Rewards! ✨️",
    paraHeading: (
      <>
        Each learning minute gets you closer to cool rewards.{" "}
        <span>Learn, collect cipherpoints, and unlock awesome goodies.</span>{" "}
        Turn your learning time into reward time 😎
      </>
    ),
    src: assets.Reward,
    backgroundColor: "#0B2D59",
    navigationLink: "https://www.cipherschools.com/redeem/rewards",
  },
  {
    heading: "Don't just learn, Earn Skill Badges for Free 🎖️",
    paraHeading: (
      <>
        Complete any{" "}
        <span>
          free course on CipherSchools and unlock a verified skill badge.
        </span>{" "}
        Show the world what you’ve learned - one badge at a time.
      </>
    ),
    src: assets.Badge,
    backgroundColor: "#0B2D59",
    navigationLink: "/certificate/verify",
  },
  {
    heading: "Learn. Code. Compile. Repeat. 👩🏻‍💻🔥",
    paraHeading: (
      <>
        Code in <span>C++, Java and more with zero setup.</span> Just type,
        compile, and run, no downloads needed.
      </>
    ),
    src: assets.Editor,
    backgroundColor: "#0F4FA2",
    navigationLink: "https://compiler.cipherschools.com/",
  },
];

export default BreakPointFeature;
